import { useEnableV2FeedPage } from 'mednet-cns/src/hooks/gregorFlags'

// Standalone function - can be used anywhere by passing the flag value
export function getTopicPath(topicId, enableV2FeedPage, params = null) {
  const queryString = params ? `?${new URLSearchParams(params).toString()}` : ''
  if (enableV2FeedPage) {
    return `/v2/topic/${topicId}/questions${queryString}`
  }
  return `/topic/${topicId}${queryString}`
}

// Hook - for use in React components
export default function useTopicPath() {
  const enableV2FeedPage = useEnableV2FeedPage()

  return {
    getTopicPath: (topicId, params) =>
      getTopicPath(topicId, enableV2FeedPage, params),
  }
}
